import React from "react";
import { observer } from "mobx-react";
import RootStore from "../stores/RootStore";

const OverlayWidgets = observer(({ uiStore }) => {
  const store = RootStore.uiStore.subUiStores["overlay"];

  return (
    <div>
      {Object.keys(store.widgets).map((widgetKey) => (
        <div key={widgetKey}>{store.widgets[widgetKey]}</div>
      ))}
    </div>
  );
});
export default OverlayWidgets;
